import { timeZones } from 'common/components/entities/Calendar/constants'

export const getLocalTimeZone = () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  return timeZones.includes(tz) ? tz : 'UTC'
}

export const formatDate = (
  date: Date,
  locale: string,
  options?: Intl.DateTimeFormatOptions,
) => {
  const defaultOptions: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  return new Intl.DateTimeFormat(locale, options ?? defaultOptions).format(date)
}
